module.exports = __webpack_public_path__ + "static/img_4409-6cc1b9c7ad85406d60fcbc8325d0361b.webp";